module.exports = __webpack_public_path__ + "img/simplepay.0be346dd.png";